import {takeEvery, call, put} from 'redux-saga/effects';
import {BudgetPageActions} from '../actions'
import axios from 'axios';
import {toastr} from 'react-redux-toastr';

const budgetUrl  = '/api/budgets';

export function* watchGetBudgetPage() {
    yield takeEvery(BudgetPageActions.GetBudgetPageAction.Request, getBudgetPage);
}
function* getBudgetPage(action) {
    try {
        const budgetPage = yield call(getBudgetPageRequest, action.payload.year, action.payload.type);
        yield put({
            type: BudgetPageActions.GetBudgetPageAction.Success,
            payload: budgetPage
        });
    } catch (e) {
        yield put({type: BudgetPageActions.GetBudgetPageAction.Failure});
        toastr.error('Pobieranie strony budżetu',
            'Wystąpił niespodziewany błąd podczas pobierania strony budżetu');

    }
}
function getBudgetPageRequest(year, type) {
    return axios.get(`${budgetUrl}/${year}/pages/type/${type}`)
        .then(response => response.data)
        .catch(err => {
            throw err;
        });
};